import React from 'react'
import { Container, Grid, Item, Menu, Label, Popup, List } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import titleCase from 'title-case'
import sortBy from 'lodash/sortBy'
import sumBy from 'lodash/sumBy'
import moment from 'moment'

import './NavBar.css'

const changeCase = {
  titleCase: titleCase
}


const _ = {
  sortBy: sortBy,
  sumBy: sumBy
}

const NavBarV = (props) => {
  if (props.auth) {
    const sortedNotifications  = _.sortBy(props.notifications, function(o) { return o.created; }).reverse();
    const notificationItems = sortedNotifications.map((notification, key) => {
      return (
        <List.Item className={notification.isRead ? 'notif-read' : 'notif-unread'} key={key} onClick={() => props.notificationClick(notification.notificationId)}>
          <List.Content>
            <List.Description>You have a notification from <span className='notification-from'>{notification.from}</span></List.Description>
            <List.Description className='notification-time'>Created {moment(notification.created).fromNow()}</List.Description>
          </List.Content>
        </List.Item>
      )
    })

    const count = _.sumBy(sortedNotifications, function(o) {
      if(o.isRead){
        return 0;
      } else {
        return 1;
      }
    });

    return (
      <div>
        <div className='main-header'>
          <Container fluid>
            <Grid centered>
              <Grid.Column widescreen={10} computer={14} mobile={16}>
                <Grid>
                  <Grid.Column width={4}>
                    <Item.Group className='orgid' unstackable>
                      <Item>
                        <Item.Content>
                          <Item.Header>
                            <h1 style={{ paddingTop:'3px', fontSize:'1.4em', color:'#FFFFFF' }}>
                              SALIS MIS
                            </h1>
                          </Item.Header>
                        </Item.Content>
                      </Item>
                    </Item.Group>
                  </Grid.Column>
                  <Grid.Column width={12} textAlign='right' style={{paddingTop:'9px'}}>
                    <Menu className='main-menu' secondary compact position='right'>
                      <Menu.Item name='home'>
                        <NavLink className='nav-link' key="home" to="/home" activeClassName="selected">
                          HOME
                        </NavLink>
                      </Menu.Item>
                      {
                        props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'staff' || props.userType === 'cashier' ?
                        <Menu.Item name='students'>
                          <NavLink className='nav-link' key="students" to="/students" activeClassName="selected">
                            STUDENTS
                          </NavLink>
                        </Menu.Item> :
                        null
                      }
                      {
                        props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'staff' || props.userType === 'cashier' ?
                        <Menu.Item name='applicants'>
                          <NavLink className='nav-link' key="applicants" to="/applicants" activeClassName="selected">
                            APPLICANTS
                          </NavLink>
                        </Menu.Item> :
                        null
                      }
                      {
                        props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'staff' || props.userType === 'cashier' ?
                        <Menu.Item name='payments'>
                          <NavLink className='nav-link' key="payments" to="/payments" activeClassName="selected">
                            PAYMENTS
                          </NavLink>
                        </Menu.Item> :
                        null
                      }
                      {
                        /* Club moderators are ordinary teachers, so the item
                           shows for them too; the page tells anyone who
                           moderates nothing that there is nothing for them. */
                        props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' ||
                        props.managesClubs || props.userType === 'teacher' || props.userType === 'adviser' || props.userType === 'levelHead' ?
                        <Menu.Item name='clubs'>
                          <NavLink className='nav-link' key="clubs" to="/clubs" activeClassName="selected">
                            CLUBS
                          </NavLink>
                        </Menu.Item> :
                        null
                      }
                      {
                        props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' ?
                        <Menu.Item name='setup'>
                          <NavLink className='nav-link' key="setup" to="/setup" activeClassName="selected">
                            SETUP
                          </NavLink>
                        </Menu.Item> :
                        null
                      }
                      {
                        props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'adviser' || props.userType === 'levelHead'?
                        <Menu.Item name='facsimile'>
                          <NavLink className='nav-link' key="setup" to="/facsimile" activeClassName="selected">
                            FACSIMILE
                          </NavLink>
                        </Menu.Item> :
                        null
                      }

                      <Popup
                        wide
                        trigger={
                          <Menu.Item as='a'>
                            <span className='nav-link-notification'>NOTIFICATIONS</span>
                            {
                              count !== 0 ?
                              <Label color='red' floating>
                                {count}
                              </Label> :
                              null
                            }
                          </Menu.Item>
                        }
                        on='click'
                        hideOnScroll
                        position='bottom center'
                        style={{padding : '0'}}
                      >
                      {
                        props.notifications.length === 0 ?
                        <List divided relaxed>
                          <List.Item style={{padding : '0.5em'}}>
                          </List.Item>
                          <List.Item style={{padding : '0.5em'}}>
                            No Available Notifications
                          </List.Item>
                          <List.Item style={{padding : '0.5em'}}>
                          </List.Item>
                        </List> :
                        <List divided relaxed>
                          <List.Item style={{padding : '0.5em'}}>
                          </List.Item>
                          {notificationItems}

                          <List.Item style={{padding : '0.5em', textAlign:'center'}}>
                            <span className='see-all-link'><u>SEE ALL</u></span>
                          </List.Item>
                        </List>
                      }
                      </Popup>
                      <Menu.Item className='nav-link' name='logout' onClick={props.logout}>
                        <strong>LOGOUT</strong>
                      </Menu.Item>
                    </Menu>
                  </Grid.Column>
                </Grid>
              </Grid.Column>
            </Grid>
          </Container>
        </div>
        <div className='content-header'>
          <Container fluid>
          <Grid centered>
            <Grid.Column className='content-bar' widescreen={10} computer={14} mobile={16}>
              <span style={{paddingLeft:'5px', fontSize:'1.35em', fontWeight:800}}>
                {props.title}
              </span>
              <Label color='blue' size='tiny' horizontal style={{
                float:'right',
                cursor:'pointer'
              }}>
                {changeCase.titleCase(props.userType)}
              </Label>
              <span style={{
                float:'right',
                color:'#196FC3',
                cursor:'pointer',
                marginLeft: '3px',
                marginRight: '3px'
              }}>
                <u>{props.username}</u>
              </span>
              <span style={{
                float:'right'
              }}>
                Logged in user:
              </span>
            </Grid.Column>
          </Grid>
          </Container>
        </div>
      </div>
    )
  } else {
    return (
      null
    )
  }

}

export default NavBarV;
